import { Checkbox as Checkbox_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Checkbox = forwardRef(({ ...props }, ref) => {
    return <Checkbox_ ref={ref} {...props}>{props?.children}</Checkbox_>
});

import { CheckboxGroup as CheckboxGroup_ } from "@chakra-ui/react";
export const CheckboxGroup = forwardRef(({ ...props }, ref) => {
    return <CheckboxGroup_ ref={ref} {...props}>{props?.children}</CheckboxGroup_>
});